export default { sha: '5c2e1ef9ebbd5bb20fc7dbbe07f6a3165ff91225', buildNumber: 'undefined' }
